import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for updateTheme mutation
 */
export interface UpdateThemeVariables {
  primary?: string;
  secondary?: string;
}

/**
 * Updated theme structure
 */
export interface UpdatedTheme {
  id: string;
  name: string;
  primary: string;
  secondary: string;
}

/**
 * Update theme payload structure
 */
export interface UpdateThemePayload {
  theme: UpdatedTheme;
}

/**
 * Response structure for updateTheme mutation
 */
export interface UpdateThemeResponse {
  theme: UpdateThemePayload;
}

const updateThemeMutation: DocumentNode = gql`
  mutation update_theme($primary: JSONString, $secondary: JSONString) {
    theme(primary: $primary, secondary: $secondary) {
      theme {
        id
        name
        primary
        secondary
      }
    }
  }
`;

export default updateThemeMutation;
